function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import { NotificationsList } from './elements';
/**
 * Notification list container
 * @param {string} children - Component containing notifications
 *
 * @return {jsx}
 */

var NotificationsListContainer = function NotificationsListContainer(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(NotificationsList, rest, children);
};
/**
 * PropTypes Validation
 */


var oneOf = PropTypes.oneOf,
    oneOfType = PropTypes.oneOfType,
    node = PropTypes.node,
    arrayOf = PropTypes.arrayOf;
NotificationsListContainer.propTypes = {
  /**
   * Position on the screen
   */
  placement: oneOf(['top-left', 'top-center', 'top-right', 'bottom-left', 'bottom-center', 'bottom-right']).isRequired,

  /**
   * Inner content
   */
  children: oneOfType([arrayOf(node), node]).isRequired
};
NotificationsListContainer.displayName = 'NotificationsListContainer';
export default NotificationsListContainer;